/**
 * GameEffectSubType enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file GameEffectSubType.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum GameEffectSubType {
  MAGICAL =       8,
  SUPERNATURAL =  16,
  EXTRAORDINARY = 24,

  MASK = 0x18
};